var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"size":_vm.size,"color":_vm.color,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }